export default "__VITE_ASSET__c9163869__"